// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text[data-v-b8172862]{color:#1a051d}.hr[data-v-b8172862]{border-top:1px solid rgba(0,0,0,.1)}", ""]);
// Exports
module.exports = exports;
